import { useTranslation } from "react-i18next";
import EmailDistribution from "./email/EmailDistribution";

function AdminNotificationConfig() {
  const { t } = useTranslation(["adminNotificationConfig"]);

  return (
    <div className="RegisterConfig">
      <div className="container-fluid">
        <div className="bg-light p-5 rounded mt-3">
          <h1>{t("general.title", { ns: "adminNotificationConfig" })}</h1>
          <p className="lead">{t("general.subText", { ns: "adminNotificationConfig" })}</p>
        </div>

        <div className="my-3 p-3 bg-light rounded shadow-sm">
          <EmailDistribution />
        </div>
      </div>
    </div>
  );
}

export default AdminNotificationConfig;
